import { apiFetch, apiFetchBlob, downloadBlob } from './core'

/**
 * createOrder(payload)
 * payload = {
 *   buyer_name: string,
 *   buyer_phone?: string,
 *   customer_uid?: string,
 *   lines: [{ product_id, qty, variants?: [] }],
 *   payment_mode?: string,
 *   payment_plan?: object,
 *   tva_pct?: number
 * }
 */
export async function createOrder(payload) {
  const clean = {
    buyer_name: payload?.buyer_name?.trim(),
    buyer_phone: payload?.buyer_phone?.trim() || null,
    ...(payload?.customer_uid ? { customer_uid: payload.customer_uid } : {}),
    lines: (payload?.lines || []).map((l) => ({
      product_id: l.product_id,
      qty: Number(l.qty),
      variants: Array.isArray(l.variants) ? l.variants : [],
    })),
    ...(payload?.payment_mode ? { payment_mode: payload.payment_mode } : {}),
    ...(payload?.payment_method ? { payment_method: payload.payment_method } : {}),
    ...(payload?.payment_provider ? { payment_provider: payload.payment_provider } : {}),
    ...(payload?.payment_reference ? { payment_reference: payload.payment_reference } : {}),
    ...(payload?.payment_note ? { payment_note: payload.payment_note } : {}),
    ...(payload?.payment_plan ? { payment_plan: payload.payment_plan } : {}),
    tva_pct: payload?.tva_pct ?? 18,
  }

  return apiFetch('/api/orders', {
    method: 'POST',
    body: clean, // ✅ apiFetch stringify auto
  })
}

/** listOrders() */
export async function listOrders() {
  return apiFetch('/api/orders')
}

/** customerSuggest(q) */
export async function customerSuggest(q, limit = 10) {
  return apiFetch(`/api/orders/customer-suggest?q=${encodeURIComponent(q)}&limit=${limit}`)
}

/** downloadInvoice(externalId) */
export async function downloadInvoice(externalId) {
  const blob = await apiFetchBlob(`/api/orders/${externalId}/pdf?download=1`)
  downloadBlob(blob, `${externalId}.pdf`)
}
